import { h, Host } from "@stencil/core";
const baseClass = "ux-checkbox";
let id = 0;
/**
 * @slot - Can be used for Label instead of the label Prop.
 */
export class Checkbox {
    constructor() {
        this.value = "";
        this.label = "";
        this.inputId = undefined;
        this.name = "";
        this.checked = false;
        this.disabled = false;
        this.required = false;
        this.error = false;
        this.errorMsg = null;
        this.noLabel = false;
    }
    /** the ux-checkbox element */
    element;
    /** the checkbox input element */
    checkboxInputElement;
    setInputId() {
        this.inputId = this.inputId || `${baseClass}-${id++}`;
    }
    componentWillLoad() {
        this.setInputId();
    }
    /** checkbox event, includes checked status, inputId and input name */
    checkboxEvent;
    onChange = (event) => {
        if (event.target !== this.checkboxInputElement) {
            return;
        }
        this.checked = this.checkboxInputElement?.checked;
        this.checkboxEvent.emit({
            checked: this.checkboxInputElement?.checked,
            // @ts-expect-error Check for typing
            inputId: this.inputId,
            name: this.name,
            value: this.value
        });
    };
    render() {
        const { value, label, inputId, name, checked, disabled, required, error, errorMsg, noLabel } = this;
        // baseClass is not used for Host element because it is also a static component
        return (h(Host, { key: '522f54b81a104d2e42f244e597f97e7d677361f0' }, h("label", { key: 'ef077d2e16d23abcbeb90427b672372b11ef535b', class: {
                [baseClass]: true,
                [`${baseClass}--disabled`]: disabled,
                [`${baseClass}--error`]: error
            } }, h("input", { key: '5699490e92b685da0e28d77a12ccbc88b7cc014d', class: `${baseClass}__input`, type: "checkbox", id: inputId, name: name, value: value, checked: checked, disabled: disabled, required: required,
            // @ts-expect-error Check for typing
            ref: (el) => (this.checkboxInputElement = el), onChange: this.onChange, "aria-invalid": error ? "true" : "false" }), h("span", { key: '5c6290bf3a573af16fb440f7258ba6c9228fbfaa', class: {
                [`${baseClass}__label`]: true,
                [`${baseClass}__label--error`]: error && errorMsg === "",
                [`${baseClass}__label--empty`]: noLabel
            } }, !noLabel ? label : null, h("span", { key: 'f86f139d29bbe2770ee2245727fdcf7e32e87658', class: `${baseClass}__slot-container` }, h("slot", { key: 'be749ea75efcaf9a4f6cecd1f3c313023a4d3fa8' })), required && h("span", { key: '287a27ee3ed70277e744d490091493f797276823' }, " *"), error && errorMsg !== "" && h("span", { key: 'd24849cbf9a745ecf1e27c5521e6eee3be8dfa59', class: "ux-label__error-message" }, errorMsg)))));
    }
    static get is() { return "ux-checkbox"; }
    static get originalStyleUrls() {
        return {
            "$": ["checkbox.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["checkbox.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "value of the input element, not visible to the user"
                },
                "attribute": "value",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "text inside the checkbox label element, visible to the user"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "inputId": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Input id attribute"
                },
                "attribute": "input-id",
                "reflect": true
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "name which is used for checkbox groups or as identifier in forms"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "checked": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox is checked"
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox is disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox is required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox has an error state"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Error message that is rendered if component has an error"
                },
                "attribute": "error-msg",
                "reflect": false,
                "defaultValue": "null"
            },
            "noLabel": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "to be set if the checkbox should not have content inside the label"
                },
                "attribute": "no-label",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "checkboxEvent",
                "name": "uxCheckboxChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "checkbox event, includes checked status, inputId and input name"
                },
                "complexType": {
                    "original": "{\n        name: string;\n        value: string;\n        inputId: string;\n        checked: boolean;\n    }",
                    "resolved": "{ name: string; value: string; inputId: string; checked: boolean; }",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "inputId",
                "methodName": "setInputId"
            }];
    }
}
//# sourceMappingURL=checkbox.js.map
